import classNames from "classnames";
import { useIntl } from "react-intl";

function Spinner({ className, size, ...restProps }) {
  const intl = useIntl();
  return (
    <span
      className={classNames(
        className,
        "relative flex h-full w-full items-center justify-center"
      )}
    >
      <span
        role="status"
        className={classNames(
          size === "xs" && "h-3 w-3 border-1",
          size === "sm" && "h-5 w-5 border-2",
          size === "lg" && "h-8 w-8 border-4",
          size === "xl" && "h-12 w-12 border-4",
          !size && "h-8 w-8 border-4",
          "border-b-primary-blue/60 box-border animate-spin rounded-full border-white"
        )}
        {...restProps}
      >
        <span className="sr-only">
          {intl.formatMessage({ id: "auth.loading", defaultMessage: "Loading…" })}
        </span>
      </span>
    </span>
  );
}

export default Spinner;
